import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import _IconLock from "@arco-design/web-react/icon/react-icon/IconLock";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconMessage from "@arco-design/web-react/icon/react-icon/IconMessage";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import request from '@/utils/request';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';
export default function ForgotForm() {
  const formRef = useRef();
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [identifierValid, setIdentifierValid] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const history = useHistory();
  const t = useLocale(locale);
  function afterResetPasswordSuccess() {
    // 跳转登录页
    window.location.href = '/login';
  }
  function resetPassword(params) {
    setErrorMessage('');
    setLoading(true);
    request.post('/v1/user/reset_password', params).then(res => {
      const {
        code,
        message
      } = res.data;
      if (code === 200) {
        afterResetPasswordSuccess();
      } else {
        setErrorMessage(message || t['forgot.form.resetPassword.errMsg']);
      }
    }).finally(() => {
      setLoading(false);
    });
  }
  function onSubmitClick() {
    formRef.current.validate().then(values => {
      resetPassword(values);
    }).catch(() => {
      // setErrorMessage(t['forgot.form.resetPassword.errMsg']);
    });
  }
  function onGetVerifyCodeClick() {
    formRef.current.validate(['identifier']).then(values => {
      setLoading(true);
      values.type = 'reset_password';
      request.post('/v1/user/verify_code', values).then(res => {
        const {
          code,
          message
        } = res.data;
        if (code === 200) {
          setCountdown(60);
        } else {
          setErrorMessage(message || t['forgot.form.getVerifyCode.errMsg']);
        }
      }).finally(() => {
        setLoading(false);
      });
    }).catch(() => {
      setIdentifierValid(false);
    });
  }
  function onValuesChange(changedValues, allValues) {
    if (changedValues.identifier !== undefined) {
      formRef.current.validate(['identifier']).then(() => {
        setIdentifierValid(true);
      }).catch(() => {
        setIdentifierValid(false);
      });
    }
  }
  React.useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['forgot-form-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['forgot-form-title']
  }, t['forgot.form.title']), /*#__PURE__*/React.createElement("div", {
    className: styles['forgot-form-sub-title']
  }, t['forgot.form.subtitle']), /*#__PURE__*/React.createElement("div", {
    className: styles['forgot-form-error-msg']
  }, errorMessage), /*#__PURE__*/React.createElement(_Form, {
    className: styles['forgot-form'],
    layout: "vertical",
    ref: formRef,
    onValuesChange: onValuesChange
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "identifier",
    rules: [{
      required: true,
      message: t['forgot.form.identifier.errMsg']
    }, {
      validator: (value, cb) => {
        if (!value) return cb();
        if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(value) && !/^1[3456789]\d{9}$/.test(value)) return cb(t['forgot.form.identifier.errMsg']);
        return cb();
      }
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    allowClear: true,
    prefix: /*#__PURE__*/React.createElement(_IconUser, null),
    placeholder: t['forgot.form.identifier.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['forgot-form-verify-actions']
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "verify_code",
    rules: [{
      required: true,
      message: t['forgot.form.verifyCode.errMsg']
    }, {
      validator: (value, cb) => {
        if (!value) return cb();
        if (!/^\d{6}$/.test(value)) return cb(t['forgot.form.verifyCode.errMsg']);
        return cb();
      }
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    allowClear: true,
    prefix: /*#__PURE__*/React.createElement(_IconMessage, null),
    placeholder: t['forgot.form.verifyCode.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Button, {
    disabled: !identifierValid || countdown > 0,
    type: "primary",
    onClick: onGetVerifyCodeClick,
    loading: loading,
    style: {
      marginLeft: 20
    }
  }, countdown > 0 ? `${countdown}s` : t['forgot.form.getVerifyCode'])), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "new_password",
    rules: [{
      required: true,
      message: t['forgot.form.password.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    prefix: /*#__PURE__*/React.createElement(_IconLock, null),
    placeholder: t['forgot.form.password.placeholder'],
    onPressEnter: onSubmitClick,
    onBlur: () => formRef.current.setFieldValue('confirm_password', '')
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "confirm_password",
    rules: [{
      required: true,
      message: t['forgot.form.password.errMsg']
    }, {
      validator: (value, cb) => {
        const password = formRef.current.getFieldValue('new_password');
        if (!password || !value) return cb();
        if (value !== password) return cb(t['forgot.form.confirmPassword.errMsg']);
        return cb();
      }
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    prefix: /*#__PURE__*/React.createElement(_IconLock, null),
    placeholder: t['forgot.form.confirmPassword.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Space, {
    size: 16,
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    long: true,
    onClick: onSubmitClick,
    loading: loading
  }, t['forgot.form.resetPassword']), /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    long: true,
    className: styles['forgot-form-login-btn'],
    onClick: () => history.push('/login')
  }, t['forgot.form.login']))));
}